import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { uploadIcon } from "@progress/kendo-svg-icons";
import { UploadRawFilesDialog } from "@presentation/components/inventory/components/UploadRawFilesDialog";
import { useUploadStore } from "@presentation/stores/UploadStore";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";

interface UploadRawFilesButtonProperties {
  onUploadSuccess?: () => void;
  folder: string;
}

export const UploadRawFilesButton: React.FC<UploadRawFilesButtonProperties> = ({ onUploadSuccess, folder }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const { activeUploads } = useUploadStore();
  const uploadingCount = Object.values(activeUploads).filter((u) => (u.status === "uploading" || u.status === "pending") && (u.type === "rawFile" || u.type === undefined)).length;

  return (
    <>
      <BadgeContainer>
        <Button svgIcon={uploadIcon} onClick={() => setIsDialogVisible(true)} title="Upload Raw Files">
          Upload Raw Files
        </Button>
        {uploadingCount > 0 && (
          <Badge themeColor="primary" size="small" align={{ vertical: "top", horizontal: "end" }}>
            {uploadingCount}
          </Badge>
        )}
      </BadgeContainer>

      {isDialogVisible && (
        <UploadRawFilesDialog
          folder={folder}
          onClose={() => setIsDialogVisible(false)}
          onUploadStarted={() => {
            // Keep the dialog open so the user can see the progress of what they just started
          }}
          onUploadSuccess={onUploadSuccess}
        />
      )}
    </>
  );
};
